module.exports = __webpack_public_path__ + "img/crypto-twd.1892fff2.svg";